export default "__VITE_PUBLIC_ASSET__cb6a9a59__"